import { createContext } from "react";

const Tadoba=createContext();

export default Tadoba;